import React from 'react';
import { withProps } from 'recompose';
import { Breadcrumbs, Crumb } from 'components/core/Breadcrumbs';

export const enhance = withProps(({ facility, baseUrl, crumbs = [] }) => ({
	location: facility.seoLocation,
	cityUrl: facility.cityUrl,
	stateUrl: facility.stateUrl,
	baseUrl,
	crumbs: facility.name
		? [
				<Crumb
					key="facility"
					label={facility.name}
					to={facility.url}
					isLast={!crumbs.length}
				/>,
				...crumbs,
			]
		: crumbs,
}));

export default enhance(Breadcrumbs);
